export const ID_VERIFICATION_DESCRIPTION =
  "Ensure compliance and prevent fraud with high-assurance identity verification. Our system uses biometric checks to confirm a contractor's government-issued ID is authentic and matches their live selfie.";

export const ID_VERIFICATION_EXAMPLE_USE_CASES =
  "Regulatory compliance (KYC), fraud prevention, age-restricted work.";

export const ID_VERIFICATION_COST = "$5.00 per verification";

export const ID_VERIFICATION = {
  description: ID_VERIFICATION_DESCRIPTION,
  exampleUseCases: ID_VERIFICATION_EXAMPLE_USE_CASES,
  cost: ID_VERIFICATION_COST
};
